// Routes necessary for navigating to Registrations V2 dashboard

export function registrationTicketsRedirect(url, slug) {
  return `${url}/tickets?slug=${slug}`;
}

export function registrationRegistrationPagePath(url, slug) {
  return `${url}/registration-page?slug=${slug}`;
}
